<div class="modal-header">
	<h4 class="modal-title">{{ isEdit() ? 'Edit' : 'Add' }} Business Branch</h4>
	<button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
	<div class="container-fluid p-2">
		<div class="d-grid grid-md-2-col gap-3" style="grid-template-columns: repeat(2, 1fr)">
			<app-select-business-license class="full-width-grid-item" [(businessId)]="businessId" [businessOnly]="true" [lockSelection]="lockBusiness"></app-select-business-license>
			<div class="form-floating full-width-grid-item">
				<input type="name" class="form-control" [(ngModel)]="branch().Name" id="name" placeholder="Branch Alias" />
				<label for="name" class="form-label">Branch Alias</label>
			</div>
    @if (!isEdit()) {
      <div class="full-width-grid-item small fw-bold text-uppercase text-secondary opacity-70 letter-spacing-1">License Details: </div>
      <mat-form-field subscriptSizing="dynamic" class="w-100">
        <mat-label>Valid From</mat-label>
        <input matInput [matDatepicker]="validSince" name="validSince" [(ngModel)]="license().ValidSince" />
        <mat-datepicker-toggle matSuffix [for]="validSince"></mat-datepicker-toggle>
        <mat-datepicker #validSince></mat-datepicker>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="w-100">
        <mat-label>Valid Until</mat-label>
        <input matInput [min]="minDate" [matDatepicker]="validUntil" name="validUntil" [(ngModel)]="license().ValidUntil" />
        <mat-datepicker-toggle matSuffix [for]="validUntil"></mat-datepicker-toggle>
        <mat-datepicker #validUntil></mat-datepicker>
      </mat-form-field>
      <div class="form-floating full-width-grid-item">
        <input type="text" required class="form-control" [(ngModel)]="license().AccountNo" id="accountNo" placeholder="Account No." />
        <label for="accountNo" class="form-label">Account No.</label>
      </div>
    }
      <div class="form-floating">
        <input type="text" required class="form-control" [(ngModel)]="branch().ContactNo" id="contact" placeholder="Contact No." (keypress)="sharedService.isNumberKey($event)" />
        <label for="contact" class="form-label">Contact No.</label>
      </div>
      <div class="form-floating">
        <input type="email" class="form-control" [(ngModel)]="branch().Email" id="email" placeholder="Email No." onblur="this.reportValidity()" />
        <label for="email" class="form-label">Email</label>
      </div>
      <div class="form-floating full-width-grid-item">
        <input type="text" required class="form-control" [(ngModel)]="branch().Address.Line0" id="line0" placeholder="Address Line 1" />
        <label for="line0" class="form-label">Address Line 1</label>
      </div>
      <div class="form-floating full-width-grid-item">
        <input type="text" class="form-control" [(ngModel)]="branch().Address.Line1" id="line1" placeholder="Address Line 2" />
        <label for="line1" class="form-label">Address Line 2</label>
      </div>
      <div class="form-floating full-width-grid-item">
        <input type="text" class="form-control" [(ngModel)]="branch().Address.Line2" id="line2" placeholder="Address Line 3" />
        <label for="line2" class="form-label">Address Line 3</label>
      </div>
      <div class="form-floating">
        <input type="text" required class="form-control" [(ngModel)]="branch().Address.PostalZone" id="postcode" placeholder="Postcode" (keypress)="sharedService.isNumberKey($event)" pattern="\d{5}" onblur="this.reportValidity()" title="5 digits postcode" />
        <label for="postcode" class="form-label">Postcode</label>
      </div>
      <div class="form-floating">
        <input type="text" required class="form-control" [(ngModel)]="branch().Address.City" id="city" placeholder="City" />
        <label for="city" class="form-label">City</label>
      </div>
      <div class="form-floating full-width-grid-item">
        <input type="text" required class="form-control" [(ngModel)]="branch().Address.State" id="state" placeholder="State" />
        <label for="state" class="form-label">State</label>
      </div>
    @if (!isEdit()) {
      <div class="form-floating full-width-grid-item">
        <textarea class="form-control" [(ngModel)]="license().Remark" placeholder="Remark" id="remark" style="height: 100px"></textarea>
        <label for="remark">Remark</label>
      </div>
    }
		</div>
		<div class="mt-3 d-flex justify-content-end gap-2">
			<button class="btn btn-light" (click)="resetBusinessBranch()">Reset</button>
			<button class="btn btn-primary" (click)="addOrUpdateBusinessBranch()">{{ isEdit() ? 'Update' : 'Add' }}</button>
		</div>
	</div>
</div>
